<template>
    <div class="bg-white">
        <Hero :title="$t('advice.title')" :lead="$t('advice.lead')" overlapped-by-content />
        <div class="relative z-10 -mt-32">
            <div class="container pb-24">
                <div v-if="advices && advices.length">
                    <div id="advices-content" class="grid grid-cols-12 gap-5">
                        <div
                            v-for="advice in advices"
                            :key="`advice-${advice.id}`"
                            class="col-span-12 sm:col-span-6 lg:col-span-4"
                        >
                            <ArticleCard
                                :url="localePath(`/job-seeker/advice/${advice.slug}`)"
                                :title="advice.title"
                                :thumbnail="advice.cover_image"
                                class="h-full"
                            />
                        </div>
                    </div>
                </div>
                <div v-else class="py-16 text-black">
                    <div class="pt-14 pb-12"></div>
                    {{ $t('generic.no_results') }}
                </div>
            </div>

            <div v-if="jobs.length" class="bg-gray-900 pt-16 pb-12 diagonally-rounded shadow-xl--custom relative z-10">
                <div class="container px-0 mb-10">
                    <SectionWrapper
                        :title="$t('job_seekers.lead')"
                        :link="{ path: localePath('/job-seeker/jobs'), label: $t('generic.all_offers') }"
                        is-carousel-wrapper
                    >
                        <JobsCarousel :jobs="jobs" />
                    </SectionWrapper>
                </div>
            </div>
            <div v-if="jobs.length" class="absolute bottom-0 left-0 w-full h-32 bg-gray-800 z-0"></div>
        </div>
    </div>
</template>

<script>
import Hero from '@/components/Heroes/Hero';
import ArticleCard from '@/components/Cards/ArticleCard/ArticleCard';
import SectionWrapper from '@/components/UI/SectionWrapper';
import JobsCarousel from '@/components/Carousels/JobsCarousel';

export default {
    name: 'Advices',
    components: {
        Hero,
        ArticleCard,
        SectionWrapper,
        JobsCarousel,
    },
    async asyncData({ $axios, redirect, localePath, $getIsLangKoZhDe }) {
        if ($getIsLangKoZhDe()) {
            return redirect(localePath('/'));
        }

        let advices = null;
        let jobs = null;

        try {
            await Promise.all([$axios.$get(`/advice`), $axios.$get('/job?is_highlighted=1')])
                .then(([advicesRes, jobsRes]) => {
                    if (advicesRes.success === 1) {
                        advices = advicesRes.data;
                    }
                    if (jobsRes.success === 1) {
                        jobs = jobsRes.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
        }

        return { advices, jobs };
    },
    head() {
        return {
            title: this.$t('advice.title'),
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: this.$getOgTitle(this.$t('advice.title')),
                },
                {
                    hid: 'title',
                    name: 'title',
                    content: this.$getOgTitle(this.$t('advice.title')),
                },
            ],
        };
    },
};
</script>

<style scoped></style>
